import { useQuery, UseQueryResult } from "react-query";
import { LIMIT_PRODUCT_PER_PAGE } from "../../constants";
import httpClient from "../http";

export type IProducts = {
  data: IProduct[];
  total: number;
};

export type IProduct = {
  _id: string;
  name: string;
  images: string[];
  description: string;
  quantity: number;
  price: number;
  skus: Isku[];
  shipping: number
};

export type Isku = {
  quantity: number;
  option: string;
  specification: string;
};

export function useProducts(
  page: number = 1,
  limit: number = LIMIT_PRODUCT_PER_PAGE,
  ids: string = ""
): UseQueryResult<IProducts> {
  const url = "product/tax";

  return useQuery(["productIndex", page, ids], async () => {
    const response = await httpClient.get(url, {
      params: {
        limit,
        page,
        ids,
      },
    });
    return response.data;
  });
}

export function useProduct(id: string): UseQueryResult<IProduct> {
  const url = `product/tax/${id}`;

  return useQuery("productShow", async () => {
    const response = await httpClient.get(url);
    return response.data;
  });
}
